import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams } from 'ag-grid-community';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { isEmpty } from 'lodash';

import { genericComparator } from '../../../../sorting/sort-utils';
import { TextFilterTypes } from '../../filter-options';

@Component({
  selector: 'app-client-reference-multi-filter',
  templateUrl: './client-reference-multi-filter.component.html',
  styleUrls: ['./client-reference-multi-filter.component.scss'],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'filter-operators-overlay-pane' },
    },
  ],
  standalone: false,
})
export class ClientReferenceMultiFilterComponent implements IFilterAngularComp {
  public filterModel: any;
  public textFilterTypes: string[] = Object.values(TextFilterTypes);
  private hideFilter: any;
  constructor() {}
  @ViewChild('textInput') textInput: ElementRef | undefined;
  public allSelected = false;
  public allChecked = false;
  public params!: IFilterParams;
  public clientReferences: ClientReferenceSetModel[] = [];
  public clientReferenceList: ClientReferenceSetModel[] = [];
  public allSelectedControl = new FormControl<boolean>(false);
  public isTextFilterCondition = false;
  public textFilterValue = new FormControl('');
  public filterOperation = new FormControl('contains');
  public filterOperation2 = new FormControl('contains');
  public selectedValue = new FormControl('');
  public joinOperator = new FormControl('AND');
  public textFilterValue2 = new FormControl('');
  public miniSearchFilter = new FormControl('');

  agInit(params: any): void {
    this.params = params;
    this.loadSortedClientReferences();
    this.miniSearchFilter.valueChanges.subscribe((res) =>
      this.onMiniFilterChange(res),
    );
    this.allSelectedControl.valueChanges.subscribe((res) =>
      this.toggleAllSelection(res),
    );
  }

  loadSortedClientReferences(): void {
    this.params.api.forEachNode((node: any) => {
      const clientReferenceText = node.data?.clientReference;
      if (clientReferenceText && clientReferenceText.length > 0) {
        const model = new ClientReferenceSetModel(clientReferenceText, false);
        if (
          !this.clientReferences?.some((existingModel) =>
            existingModel.equals(model),
          )
        ) {
          this.clientReferences?.push(model);
        }
      }
    });
    this.clientReferences.sort(
      (a: ClientReferenceSetModel, b: ClientReferenceSetModel) =>
        genericComparator(a.clientReferenceText!, b.clientReferenceText!),
    );
    this.clientReferenceList = this.clientReferences;
  }

  twoConditionActive(event: any): void {
    const value = event.target.value;
    this.isTextFilterCondition = value.toString().length !== 0;
  }

  getModel(): any {
    if (!this.isFilterActive()) {
      return null;
    }
    const setFilter = this.clientReferences
      .filter((f) => f.checked === true)
      .map((m) => m.clientReferenceText);

    return {
      ...(this.textFilterValue2.value && this.textFilterValue.value
        ? {
            textFilter: this.getTextFilterWithJoinCondition(),
            joinOperator: this.joinOperator.value,
          }
        : { textFilter: this.getTextFilter() }),
      selectedValue: { values: setFilter },
      filterType: 'customSetAndText',
    };
  }

  setModel(model: any): void {
    this.clearFilter();
    this.clientReferences = [];
    this.clientReferenceList = [];
    this.loadSortedClientReferences();
    const selectedValues = new Set<string>(
      model?.selectedValue?.values.filter((value: string) => !isEmpty(value)) ??
        [],
    );
    this.clientReferences.forEach((clientReference) => {
      clientReference.checked = Boolean(
        clientReference.clientReferenceText &&
          selectedValues.has(clientReference.clientReferenceText),
      );
    });
    if (!isEmpty(model?.textFilter)) {
      if (model?.textFilter.filter) {
        this.textFilterValue.setValue(model?.textFilter.filter);
        this.filterOperation.setValue(model?.textFilter.type);
      } else {
        this.textFilterValue.setValue(model?.textFilter.condition1.filter);
        this.filterOperation.setValue(model?.textFilter.condition1.type);
        if (model?.joinOperator) {
          this.joinOperator.setValue(model?.joinOperator);
        }
        if (model?.textFilter.condition2?.filter) {
          this.textFilterValue2.setValue(model?.textFilter.condition2?.filter);
          this.filterOperation2.setValue(model?.textFilter.condition2?.type);
        }
      }
      this.isTextFilterCondition = true;
    }
    this.clientReferenceList = this.clientReferences;
    this.filterModel = model;
  }

  afterGuiAttached(params: any): void {
    this.hideFilter = params.hidePopup;
    this.textInput?.nativeElement.focus();
    this.loadSortedClientReferences();
  }

  doesFilterPass(params: any): boolean {
    if (!this.filterModel) {
      return true;
    }

    const data = params.data.clientReference || '';
    const textFilter = this.filterModel.textFilter;
    const setFilter = this.filterModel.selectedValue;
    let doesFilterPass = false;
    if (textFilter && Object.entries(textFilter).length !== 0) {
      doesFilterPass ||= this.checkRowAgainstTextFilter(textFilter, data);
    }
    if (setFilter) {
      doesFilterPass ||= setFilter.values.indexOf(data) !== -1;
    }
    return doesFilterPass;
  }

  checkRowAgainstTextFilter(textFilter: any, data: any): boolean {
    const joinOperator = this.filterModel.joinOperator;
    let filterText1 = '';
    let filterText2 = '';
    let filterType1 = '';
    let filterType2 = '';
    if (joinOperator) {
      filterText1 = textFilter.condition1.filter.toString().toLowerCase();
      filterText2 = textFilter.condition2.filter.toString().toLowerCase();

      filterType1 = textFilter.condition1.type.toString();
      filterType2 = textFilter.condition2.type.toString();
    } else {
      filterText1 = textFilter.filter.toString().toLowerCase();
      filterType1 = textFilter.type.toString();
    }
    switch ((TextFilterTypes as any)[filterType1]) {
      case TextFilterTypes.contains:
        if (joinOperator) {
          return joinOperator === 'AND'
            ? data.toString().toLowerCase().indexOf(filterText1) !== -1 &&
                this.checkSecondFilterConditionForJoinOperator(
                  filterType2,
                  filterText2,
                  data,
                )
            : data.toString().toLowerCase().indexOf(filterText1) !== -1 ||
                this.checkSecondFilterConditionForJoinOperator(
                  filterType2,
                  filterText2,
                  data,
                );
        } else {
          return data.toString().toLowerCase().indexOf(filterText1) !== -1;
        }

      case TextFilterTypes.equals:
        if (joinOperator) {
          return joinOperator === 'AND'
            ? data.toString().toLowerCase() === filterText1 &&
                this.checkSecondFilterConditionForJoinOperator(
                  filterType2,
                  filterText2,
                  data,
                )
            : data.toString().toLowerCase() === filterText1 ||
                this.checkSecondFilterConditionForJoinOperator(
                  filterType2,
                  filterText2,
                  data,
                );
        } else {
          return data.toString().toLowerCase() === filterText1;
        }

      case TextFilterTypes.notEqual:
        if (joinOperator) {
          return joinOperator === 'AND'
            ? data.toString().toLowerCase() !== filterText1 &&
                this.checkSecondFilterConditionForJoinOperator(
                  filterType2,
                  filterText2,
                  data,
                )
            : data.toString().toLowerCase() !== filterText1 ||
                this.checkSecondFilterConditionForJoinOperator(
                  filterType2,
                  filterText2,
                  data,
                );
        } else {
          return data.toString().toLowerCase() !== filterText1;
        }
      case TextFilterTypes.startsWith:
        if (joinOperator) {
          return joinOperator === 'AND'
            ? data.toString().toLowerCase().indexOf(filterText1) === 0 &&
                this.checkSecondFilterConditionForJoinOperator(
                  filterType2,
                  filterText2,
                  data,
                )
            : data.toString().toLowerCase().indexOf(filterText1) === 0 ||
                this.checkSecondFilterConditionForJoinOperator(
                  filterType2,
                  filterText2,
                  data,
                );
        } else {
          return data.toString().toLowerCase().indexOf(filterText1) === 0;
        }
      case TextFilterTypes.endsWith: {
        const idx = data.toString().toLowerCase().lastIndexOf(filterText1);
        if (joinOperator) {
          return joinOperator === 'AND'
            ? idx >= 0 &&
                idx === data.length - filterText1.length &&
                this.checkSecondFilterConditionForJoinOperator(
                  filterType2,
                  filterText2,
                  data,
                )
            : (idx >= 0 && idx === data.length - filterText1.length) ||
                this.checkSecondFilterConditionForJoinOperator(
                  filterType2,
                  filterText2,
                  data,
                );
        } else {
          return idx >= 0 && idx === data.length - filterText1.length;
        }
      }
      default:
        return false;
    }
  }

  checkSecondFilterConditionForJoinOperator(
    filterType: any,
    filter: any,
    data: any,
  ): boolean {
    switch ((TextFilterTypes as any)[filterType]) {
      case TextFilterTypes.contains:
        return data.toString().toLowerCase().indexOf(filter) !== -1;
      case TextFilterTypes.equals:
        return data.toString().toLowerCase() === filter;
      case TextFilterTypes.notEqual:
        return data.toString().toLowerCase() !== filter;
      case TextFilterTypes.startsWith:
        return data.toString().toLowerCase().indexOf(filter) === 0;
      case TextFilterTypes.endsWith: {
        const idx = data.toString().toLowerCase().lastIndexOf(filter);
        return idx >= 0 && idx === data.length - filter.length;
      }
      default:
        return false;
    }
  }
  getModelAsString(): string {
    return '';
  }

  applyFilter(): void {
    this.filterModel = this.getModel();
    this.params.filterChangedCallback();
    this.hideFilter?.();
  }

  clearFilter(): void {
    this.joinOperator.setValue('AND');
    this.textFilterValue.setValue('');
    this.textFilterValue2.setValue('');
    this.filterOperation.setValue('contains');
    this.filterOperation2.setValue('contains');
    this.clientReferences.forEach((f) => {
      f.checked = false;
    });
    this.miniSearchFilter.setValue('');
    this.allChecked = false;
    this.isTextFilterCondition = false;
    this.filterModel = null;
  }

  onNewRowsLoaded(): void {}

  onMiniFilterChange(value: any): void {
    if (value.toString().trim()) {
      this.clientReferences = this.clientReferenceList
        ?.filter((reference) =>
          Boolean(
            reference.clientReferenceText
              ?.toLowerCase()
              .includes(value.toLowerCase()),
          ),
        )
        .map((reference) => reference);
    } else {
      this.clientReferences = this.clientReferenceList;
    }
  }

  isFilterActive(): boolean {
    return (
      this.textFilterValue.value?.length !== 0 ||
      this.clientReferences.filter((obj) => obj.checked).length > 0
    );
  }

  onCheckboxChangeWithLabel(
    checkbox: MatCheckbox,
    clientReference: ClientReferenceSetModel,
  ): void {
    checkbox.toggle();
    const syntheticEvent = {
      checked: checkbox.checked,
      source: {
        value: clientReference,
      },
    };
    this.onCheckboxChange(syntheticEvent);
  }

  onCheckboxChange(event: any): void {
    if (event.checked) {
      this.clientReferences.every((obj) => {
        return this.changeModelSelection(
          obj,
          event.source.value.clientReferenceText,
          true,
        );
      });
    } else {
      this.clientReferences.every((obj) => {
        return this.changeModelSelection(
          obj,
          event.source.value.clientReferenceText,
          false,
        );
      });
    }
  }

  changeModelSelection(
    clientReferenceModel: any,
    value: any,
    changeValue: boolean,
  ): boolean {
    if (value === clientReferenceModel.clientReferenceText) {
      clientReferenceModel.checked = changeValue;
      return false;
    } else {
      return true;
    }
  }

  isIndeterminate(): boolean {
    if (!this.allSelected) {
      if (this.clientReferences.filter((obj) => obj.checked).length > 0) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  toggleAllSelection(value: boolean | string | null): void {
    const shouldCheck = value === true || value === 'true';
    this.clientReferences.forEach((obj) => {
      obj.checked = shouldCheck;
    });
    this.allChecked = shouldCheck;
  }

  onAnyFilterChanged(): void {}

  getTextFilterTypeKey(value: any): string {
    return Object.keys(TextFilterTypes)[
      Object.values(TextFilterTypes).indexOf(value)
    ];
  }

  private getTextFilterWithJoinCondition(): any {
    return {
      condition1: {
        ...(this.textFilterValue.value && {
          filter: this.textFilterValue.value,
        }),
        type: this.filterOperation.value,
      },
      condition2: {
        ...(this.textFilterValue2.value && {
          filter: this.textFilterValue2.value,
        }),
        type: this.filterOperation2.value,
      },
    };
  }
  private getTextFilter(): any {
    return {
      ...(this.textFilterValue.value && {
        filter: this.textFilterValue.value,
        type: this.filterOperation.value,
      }),
    };
  }
}

export class ClientReferenceSetModel {
  clientReferenceText?: string;
  checked?: boolean;

  constructor(clientReferenceText: string, checked: boolean) {
    this.clientReferenceText = clientReferenceText;
    this.checked = checked;
  }
  equals(other: ClientReferenceSetModel): boolean {
    return this.clientReferenceText === other.clientReferenceText;
  }
}
